/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Layout,
  Menu,
  Spin,
} from 'antd';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';
import {
  ACCESS_TOKEN_EXPIRY_KEY,
  ACCESS_TOKEN_KEY,
  USER_ID,
  USER_PERMISSIONS,
} from '../../../store/modules/user/user.constants';
import { ReactComponent as Logo } from '../../../assets/icons/logo.svg';
import { ReactComponent as LogoSmall } from '../../../assets/icons/logoSmall.svg';
import { ReactComponent as Logout } from '../../../assets/icons/logout.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrowRight.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrowLeft.svg';
import { ReactComponent as AssetsSVG } from '../../../assets/icons/assets.svg';
import SidebarItems from './bar-items';
import AboutModal from '../modal';
import './sidebar.less';
import { useStore } from '../../../store';

export interface ISidebar {
  collapsedBar: boolean;
  collapseHandler: (arg0: boolean) => void;
}

const Sidebar = ({ collapsedBar, collapseHandler }: ISidebar): JSX.Element => {
  const { Sider } = Layout;
  const { location } = useHistory();
  const state = useStore();
  const [visible, setVisible] = useState(false);
  const [about, setAbout] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { userActions } = useActions();
  const localStorageService = useLocalStorage();
  const token: string | null = localStorageService.get(ACCESS_TOKEN_KEY);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const permissions: { [key: string]: any } | null = localStorageService.get(USER_PERMISSIONS);
  const {
    permission, currentUser,
  } = useStore();

  const logout = () => {
    if (token) {
      const authTypeInfo = state.authType.data;
      const isOauth2 = authTypeInfo?.auth_type === 'OAUTH2';
      const isOpenID = authTypeInfo?.auth_type === 'OPENID';
      if (isOpenID || isOauth2) {
        localStorageService.remove(ACCESS_TOKEN_KEY);
        localStorageService.remove(ACCESS_TOKEN_EXPIRY_KEY);
        localStorageService.remove(USER_ID);
        localStorageService.remove(USER_PERMISSIONS);
        window.location.href = '/user-manager/api/logout';
      } else {
        userActions.logout({ refreshToken: token });
      }
    }
  };

  const initialSelectedTab = SidebarItems
    .find((el) => el.pathname === location.pathname || location.pathname.includes(el.pathname));
  const aboutHandler = () => {
    setVisible(!visible);
  };

  const checkSinglePermission = (perm: string) => Boolean(permissions?.[perm]?.read);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkMenuPermission = (item: any) => {
    if (item === 'account') return true;
    let hasPermission = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item.split(',').forEach((page: any) => {
      if (checkSinglePermission(page) || hasPermission) {
        hasPermission = true;
      }
    });
    return hasPermission;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const menuItem = (item: any) => (
    <React.Fragment key={item.pathname}>
      <Menu.Item key={item.key} icon={<item.icon className="sidebar__icon" />}>
        <Link className="sidebar__link" to={item.pathname}>
          {item.title}
        </Link>
      </Menu.Item>
    </React.Fragment>
  );
  return !permission.loading ? (
    <>
      <AboutModal
        visible={visible}
        handler={aboutHandler}
        value={about}
        isLoading={isLoading}
        width={500}
        height={600}
      />
      <Sider
        width="258"
        breakpoint="md"
        collapsedWidth="64"
        className="sidebar"
        collapsed={collapsedBar}
      >
        <div className="tenant_name">{currentUser.data.tenant}</div>
        <div style={{ marginLeft: collapsedBar ? 20 : 34, width: collapsedBar ? 30 : 200 }} className={`sidebar__logo ${collapsedBar ? 'sidebar__logo--collapsed' : ''}`}>
          {collapsedBar ? <LogoSmall className="sidebar__logo-img--collapsed" /> : <Logo className="sidebar__logo-open" />}
          <button onClick={() => collapseHandler(!collapsedBar)} type="button" className={`sidebar__collapse ${collapsedBar ? 'sidebar__collapse--collapsed' : ''}`}>
            {collapsedBar ? <ArrowRight /> : <ArrowLeft />}
          </button>
        </div>
        <Menu
          theme="light"
          mode="inline"
          style={{ width: '100%' }}
          defaultSelectedKeys={[initialSelectedTab?.key || '0']}
        >
          {SidebarItems.map((item) => {
            if (checkMenuPermission(item.permissionId)) {
              return menuItem(item);
            }
            return null;
          })}
          <Menu.Item key="about" icon={<AssetsSVG className="sidebar__icon" />}>
            <Link
              className="sidebar__link"
              to="#"
              onClick={async () => {
                setIsLoading(true);
                setVisible(true);
                if (about) {
                  setIsLoading(false);
                } else {
                  const getAboutData = await userActions.getAboutAPI();
                  const {
                    REACT_APP_VERSION,
                    REACT_APP_DESCRIBE,
                    REACT_APP_DESCRIBE_ALL,
                    REACT_APP_DESCRIBE_TAGS,
                    REACT_APP_DESCRIBE_TAGS_ABBREV,
                    REACT_APP_BRANCH,
                    REACT_APP_COMMIT,
                    REACT_APP_DATE,
                    REACT_APP_TIME,
                  } = process.env;
                  getAboutData.ui = {
                    version_describe: REACT_APP_DESCRIBE || '',
                    version_describe_tags_abbrev: REACT_APP_DESCRIBE_TAGS_ABBREV || '',
                    version_branch: REACT_APP_BRANCH || '',
                    version_date: REACT_APP_DATE || '',
                    version_time: REACT_APP_TIME || '',
                    version_describe_tags: REACT_APP_DESCRIBE_TAGS || '',
                    version_describe_all: REACT_APP_DESCRIBE_ALL || '',
                    version_commit: REACT_APP_COMMIT || '',
                    version: REACT_APP_VERSION || '',
                  };

                  const aboutData = JSON.stringify(getAboutData, null, 2);
                  setAbout(aboutData);
                  setIsLoading(false);
                }
              }}
            >
              About
            </Link>
          </Menu.Item>
          <Menu.Item key="logout_btn" className="sidebar__bottom sidebar__bottom-second" icon={<Logout className="sidebar__icon" />}>
            <a className="sidebar__link" onClick={logout}>
              Logout
            </a>
          </Menu.Item>
        </Menu>
      </Sider>
    </>
  ) : <Spin style={{ margin: 'auto' }} size="large" />;
};

export default Sidebar;
